import React from 'react';
import Textfield from '@atlaskit/textfield';
export const EditLongText = ({
  id,
  value,
  isInvalid,
  onChange
}) => {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Textfield, {
    id: id,
    value: value,
    isInvalid: isInvalid,
    onChange: onChange,
    label: "long text",
    "aria-label": "long text field",
    title: "long text",
    placeholder: ""
  }));
};